import React, { useState } from "react";
import logo from "../../assets/logo.png";
import { BsTwitter } from "react-icons/bs";
import { FaDiscord, FaInstagram } from "react-icons/fa";
import { AiOutlineMenu, AiFillInstagram } from "react-icons/ai";
import Sidebar from "./../Sidebar/Sidebar";
import { Link, useNavigate } from "react-router-dom";
function Nav(props) {
  const [showSidebar, setShowSidebar] = useState(true);
  const handleShowSidebar = () => {
    setShowSidebar(!showSidebar);
  };
  let navigate = useNavigate();
  return (
    <div className="flex items-center justify-between w-full ">
      <div className="fixed bg-[#b6c0e8f2] md:hidden top-0 left-0 right-0 py-7 z-30">
        <div className="block border fixed top-2 z-20 left-2 border-[#FFf] rounded flex py-2  justify-center sm:hidden w-[60px]">
          <h1 className="text-white">
            <AiOutlineMenu
              size={20}
              onClick={handleShowSidebar}
              className="text-center"
              color="#fff"
            />
          </h1>
        </div>
        <div className="items-center cursor-pointer md:hidden">
          <img
            src={logo}
            alt=""
            className="fixed top-2 z-30 left-[30%] right-[30%]"
            onClick={() => navigate("/")}
          />
        </div>
      </div>
      <Sidebar
        showSidebar={showSidebar}
        handleShowSidebar={handleShowSidebar}
      />
      <div className=" w-full fixed bg-[#b6c0e8f2] top-0 left-0 right-0 py-6 hidden md:flex z-20 items-center lg:px-[120px] 2xl:px-[200px] md:px-5  md:justify-between">
        <div className="items-center hidden cursor-pointer md:flex">
          <img src={logo} alt="" onClick={() => navigate("/")} />
        </div>
        <div className="flex items-center justify-around w-full md:w-6/12 lg:w-5/12 md:justify-between">
          <a
            className="text-[14px] text-[#494970] font-medium hover:text-white"
            href="/"
            onClick={(e) => {
              let hero = document.getElementById("about");
              e.preventDefault();
              hero &&
                hero.scrollIntoView({ behavior: "smooth", block: "start" });
              window.history.pushState("about", "about", "/about");
            }}
          >
            About
          </a>
          <a
            className="text-[14px] text-[#494970] font-medium hover:text-white"
            href="/"
            onClick={(e) => {
              let hero = document.getElementById("roadmap");
              e.preventDefault();
              hero &&
                hero.scrollIntoView({ behavior: "smooth", block: "start" });
              window.history.pushState("roadmap", "roadmap", "/roadmap");
            }}
          >
            Roadmap
          </a>
          <a
            className="text-[14px] text-[#494970] font-medium hover:text-white"
            href="/"
            onClick={(e) => {
              let hero = document.getElementById("lore");
              e.preventDefault();
              hero &&
                hero.scrollIntoView({ behavior: "smooth", block: "start" });
              window.history.pushState("lore", "lore", "/lore");
            }}
          >
            Lore
          </a>
          <a
            className="text-[14px] text-[#494970] font-medium hover:text-white"
            href="/"
            onClick={(e) => {
              let hero = document.getElementById("campaign");
              e.preventDefault();
              hero &&
                hero.scrollIntoView({ behavior: "smooth", block: "start" });
              window.history.pushState("campaign", "campaign", "/campaign");
            }}
          >
            Give Campaign
          </a>
          <a
            className="text-[14px] text-[#494970] font-medium hover:text-white"
            href="/"
            onClick={(e) => {
              let hero = document.getElementById("team");
              e.preventDefault();
              hero &&
                hero.scrollIntoView({ behavior: "smooth", block: "start" });
              window.history.pushState("team", "team", "/team");
            }}
          >
            Team
          </a>

          <a
            className="text-[14px] text-[#494970] font-medium hover:text-white"
            href="/"
            onClick={(e) => {
              let hero = document.getElementById("faq");
              e.preventDefault();
              hero &&
                hero.scrollIntoView({ behavior: "smooth", block: "start" });
              window.history.pushState("faq", "faq", "/faq");
            }}
          >
            FAQ
          </a>

          {/* <button className="btn bg-black hover:bg-[#6c77ea] transition ease-in-out duration-300 text-white py-[6px] px-[20px] ">
          Connect with wallet
        </button> */}
        </div>
        <div className="flex justify-around items-center md:w-2/12 lg:w-3/12 ">
          {" "}
          <div className="lg:flex justify-between hidden w-3/12 ml-5">
            <a href="https://twitter.com/handiverseNFT">
              <BsTwitter
                className="hidden lg:block social-media-icon text-[#494970] ml-3 hover:text-white cursor-pointer "
                size={20}
              />
            </a>
            <a href="https://www.instagram.com/handiversenft/">
              {" "}
              <AiFillInstagram
                className="hidden lg:block social-media-icon text-[#494970] ml-3 hover:text-white cursor-pointer "
                size={20}
              />
            </a>
          </div>
          <div class="max-w-[200px] flex items-center justify-center text-white max-h-[60px] rounded-sm py-[3px] px-[2px] button-custom">
            <div
              onClick={() => navigate("/mint")}
              class="w-full h-full relative hover: btn cursor-pointer text-white lg:text-sm text-[12px] rounded-md px-[15px] py-[10px] bg-[#2B2B46]"
            >
              Connect Wallet
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Nav;
